export const ATTENDANCE_SETTING_DEFAULTS = Object.freeze({
  pre_buffer: '00:00',
  post_buffer: '00:00',
  work_time_unit: '00:01',
  work_basic: '08:00',
  break_basic: '01:00',
  post_work_break_flg: false,
  use_project_break_flg: false,
  // **既定は「使う」。**いま全社で使えているものを取り上げない。
  half_day_leave_flg: true
})

const TIME_PATTERN = /^(\d{1,2}):([0-5]\d)$/

const normalizedTime = (value, fallback, positive = false) => {
  const text = value == null ? '' : String(value).trim()
  const match = TIME_PATTERN.exec(text)
  if (!match) return fallback

  const hours = Number(match[1])
  const minutes = Number(match[2])
  if (!Number.isInteger(hours) || hours < 0 || hours > 23) return fallback

  const totalMinutes = hours * 60 + minutes
  if (!Number.isSafeInteger(totalMinutes) || (positive && totalMinutes <= 0)) {
    return fallback
  }

  return `${String(hours).padStart(2, '0')}:${match[2]}`
}

export const createAttendanceSettingDefaults = () => ({
  ...ATTENDANCE_SETTING_DEFAULTS
})

/**
 * API・初期フォーム・勤務表計算で同じ設定値を使う。
 *
 * 設定済みの猶予・切上げ・所定時間・休憩は維持する。旧契約企業のNULL、
 * 空文字、不正値だけを安全な既定値へ寄せる。時間外切上げ単位の未設定・
 * 00:00は、日次実績を丸めない1分単位とする。
 */
export const normalizeAttendanceSettings = source => {
  const value = source && typeof source === 'object' ? source : {}
  return {
    ...value,
    pre_buffer: normalizedTime(
      value.pre_buffer,
      ATTENDANCE_SETTING_DEFAULTS.pre_buffer
    ),
    post_buffer: normalizedTime(
      value.post_buffer,
      ATTENDANCE_SETTING_DEFAULTS.post_buffer
    ),
    work_time_unit: normalizedTime(
      value.work_time_unit,
      ATTENDANCE_SETTING_DEFAULTS.work_time_unit,
      true
    ),
    work_basic: normalizedTime(
      value.work_basic,
      ATTENDANCE_SETTING_DEFAULTS.work_basic
    ),
    break_basic: normalizedTime(
      value.break_basic,
      ATTENDANCE_SETTING_DEFAULTS.break_basic
    ),
    post_work_break_flg: value.post_work_break_flg === true,
    use_project_break_flg: value.use_project_break_flg === true,
    /*
     * **=== true にしない。**他のフラグは既定が「使わない」なので
     * それで合うが、こちらは既定が「使う」。読めなかったときに
     * 「使えない」へ倒すと、いま半休を使っている会社の運用が止まる。
     */
    half_day_leave_flg: value.half_day_leave_flg !== false
  }
}
